import React, { useState, useEffect } from "react";
import { Box, useTheme, InputBase, IconButton } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import SearchIcon from "@mui/icons-material/Search";
import { getHistorialDeposito } from "../../services/amoxarifado.services";
import ModalImage from "../../modal/imagen/modalImagen";
import { getApiImagen } from "../../utils/getApiBaseUrl";

const HistorialDeposito = () => {
  const [data, setData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const handleCloseImageModal = () => {
    setSelectedImage(null);
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.1 },
    {
      field: "operacion",
      headerName: "Operación",
      flex: 0.5,
      cellClassName: "name-column--cell",
      renderCell: (params) => (
        <span
          style={{
            color:
              params.value === "Entrada" || params.value === "Devolucion"
                ? "#fff"
                : "#ff6105",
          }}
        >
          {params.value}
        </span>
      ),
    },
    {
      field: "producto",
      headerName: "Producto",
      flex: 0.8,
      cellClassName: "name-column--cell",
    },
    {
      field: "cantidad",
      headerName: "Cantidad",
      flex: 0.4,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <span style={{ color: params.value < 0 ? "red" : "#fff" }}>
          {params.value}
        </span>
      ),
    },
    {
      field: "deposito",
      headerName: "Depósito",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "sector",
      headerName: "Sector",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "valor_patrimonio",
      headerName: "Patrimonio",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "usuario",
      headerName: "Usuario",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "usuario_re",
      headerName: "Prestado a",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "id_nota",
      headerName: "Nota",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "obs",
      headerName: "Observación",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "id_ticket",
      headerName: "ID Ticket",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "imagen",
      headerName: "Imagen",
      flex: 0.3,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <img
          src={`${getApiImagen()}${params.value}`}
          alt="Producto"
          style={{ width: "100px", height: "100px", objectFit: "cover" }}
          onClick={() =>
            handleImageClick(`${getApiImagen()}${params.value}`)
          }
        />
      ),
    },
  ];

  useEffect(() => {
    const fetchProducto = async () => {
      try {
        const response = await getHistorialDeposito();
        setData(response);
        setFilteredData(response);
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      }
    };
    fetchProducto();
  }, []);

  const handleSearchChange = (event) => {
    const { value } = event.target;
    setSearchValue(value);

    const filtered = data.filter((item) =>
      item.producto?.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredData(filtered);
  };

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" p={0}>
        <Header title="Historial" subtitle="Historial" />
        <Box display="flex" alignItems="center">
          <Box
            display="flex"
            backgroundColor={colors.primary[400]}
            borderRadius="3px"
            height={"40%"}
            width={"90%"}
            ml={1}
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="Buscar"
              value={searchValue}
              onChange={handleSearchChange}
            />
            <IconButton type="button" sx={{ p: 1 }}>
              <SearchIcon />
            </IconButton>
          </Box>
        </Box>
      </Box>

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[900],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[900],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
          "& .fila-salida": {
            backgroundColor: "#ffdddd",
            color: "#000",
          },
          "& .fila-devolucion": {
            backgroundColor: "#fff2cc",
            color: "#000",
          },
          // Estilos para las filas con hover
          "& .estado-pendiente": {
            backgroundColor: "#740017", // Color de texto
            textShadow: "2px 2px 2px 2px #ffffff",
            "&:hover": {
              backgroundColor: "rgb(27 33 54) !important", // Fondo al pasar el ratón
            },
          },
          "& .estado-completo": {
            backgroundColor: "green",
            textShadow: "2px 2px 2px 2px #ffffff",
            "&:hover": {
              backgroundColor: "rgb(27 33 54) !important", // Fondo al pasar el ratón
            },
          },
          "& .estado-en-proceso": {
            backgroundColor: "#ff6105",
            textShadow: "2px 2px 2px 2px #ffffff",
            color: "white !important",
            "&:hover": {
              backgroundColor: "rgb(27 33 54) !important", // Fondo al pasar el ratón
            },
          },
          "& .estado-default": {
            color: "gray",
            textShadow: "2px 2px 2px 2px #ffffff",
            "&:hover": {
              backgroundColor: "rgb(27 33 54) !important", // Fondo al pasar el ratón
            },
          },
        }}
      >
        <DataGrid
          rows={filteredData}
          getRowId={(row) => row.id}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
          disableMultipleSelection={true}
        />
        <ModalImage
          open={Boolean(selectedImage)}
          onClose={handleCloseImageModal}
          imageSrc={selectedImage}
        />
      </Box>
    </Box>
  );
};

export default HistorialDeposito;
